module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 232);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Paragraph = __webpack_require__(233);

var _Paragraph2 = _interopRequireDefault(_Paragraph);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Paragraph2.default;

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Paragraph;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = __webpack_require__(3);

var _bind2 = _interopRequireDefault(_bind);

var _size = __webpack_require__(234);

var _size2 = _interopRequireDefault(_size);

var _color = __webpack_require__(235);

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var paragraphStyles = _extends({}, _size2.default, _color2.default);
var cx = _bind2.default.bind(paragraphStyles);

/**
 * The heading component provides a quick way to style any heading with a font
 * size from our typography scale, color from our color palette and a HTML tag
 * of choice.
 */
function Paragraph(_ref) {
  var children = _ref.children,
      size = _ref.size,
      color = _ref.color,
      id = _ref.id,
      tag = _ref.tag;

  var CustomTag = tag;
  var paragraphProps = {
    className: cx(size, color),
    id: id
  };
  return _react2.default.createElement(
    CustomTag,
    paragraphProps,
    children
  );
}

Paragraph.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired,
  color: _propTypes2.default.oneOf(['black', 'steel', 'slate', 'silver', 'smoke', 'darkSmoke', 'extraDarkSmoke', 'snow', 'darkSnow', 'extraDarkSnow', 'white', 'green', 'red', 'blue']),
  id: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xxxl', 'xxl', 'xl', 'l', 'm', 's', 'xs']),
  tag: _propTypes2.default.oneOf(['div', 'span', 'p'])
};

Paragraph.defaultProps = {
  color: 'black',
  size: 'm',
  tag: 'p'
};

/***/ }),

/***/ 234:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"xxxl":"size__xxxl___PelCv breakPointL-fontSize-xxxl breakPointM-fontSize-xxl breakPointS-fontSize-xl fontSize-l lineHeight-copy","xxl":"size__xxl___2uFso breakPointL-fontSize-xxl breakPointM-fontSize-xl breakPointS-fontSize-l fontSize-l lineHeight-copy","xl":"size__xl___3VnYh breakPointL-fontSize-xl breakPointM-fontSize-l breakPointS-fontSize-m fontSize-s lineHeight-copy","l":"size__l___2RI3r fontSize-m lineHeight-copy breakPointM-fontSize-l","m":"size__m___Wii-G fontSize-s lineHeight-copy breakPointM-fontSize-m","s":"size__s___RlVdR fontSize-s lineHeight-copy"};

/***/ }),

/***/ 235:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"black":"color__black___--buv c-black","steel":"color__steel___2hzJV c-steel","slate":"color__slate___35wQZ c-slate","silver":"color__silver___1GcWN c-silver","smoke":"color__smoke___2R4Iv c-smoke","darkSmoke":"color__darkSmoke___2rScH c-smoke--d","extraDarkSmoke":"color__extraDarkSmoke___CJ8Ii c-smoke--xd","snow":"color__snow___1FvLh c-snow","darkSnow":"color__darkSnow___11Bxu c-snow--d","extraDarkSnow":"color__extraDarkSnow___k2WQT c-snow--xd","white":"color__white___2Uwip c-white","green":"color__green___10tLr c-green","darkGreen":"color__darkGreen___1BV6A c-green--d","red":"color__red___1DEtm c-red","blue":"color__blue___sQ5t9 c-blue"};

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("classnames/bind");

/***/ })

/******/ });
//# sourceMappingURL=marvel-ui-paragraph.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@marvelapp/marvel-ui/lib/marvel-ui-paragraph.js
// module id = 1111
// module chunks = 168707334958949